






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {RequestSsw} from '@/model/resource/RequestSsw'
import {InputRequestSswSchema} from '@/schema/resource/RequestSsw/InputRequestSswSchema'

@Component
export default class PersistRequestSswView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputRequestSswSchema()
  requestSsw = new RequestSsw()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.requestSsw.getRequestSsw(id)
    }

    $.await.done('getRequestSsw')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.requestSsw.persistRequestSsw()
    await Helper.successAndPush('system.success.persist', '/request-ssw/list')
  }
}
